import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const useStyles = makeStyles((theme) => ({
    checked: {
        color: `${theme.mainTheme.color1} !important`,
    },
    label: {
        color: theme.mainTheme.color1,
        fontSize: theme.fontSize.body1,
    },
    fontLabel: {
        fontSize: theme.fontSize.body1,
    },
    formHelper: {
        color: theme.mainTheme.color5,
        marginTop: '1px',
        marginLeft: '10px',
    },
    fullWidth: {
        width: '100%',
    },
    colorErr: {
        color: theme.mainTheme.color5,
    },
    styleMui: {
        '& svg': {
            width: '23px',
        },
    },
    fieldLabelHelperText: {
        color: theme.mainTheme.color5,
        fontSize: '15px',
        marginLeft: '4px',
        [theme.breakpoints.down('xs')]: {
            display: 'block',
        },
    },
}));

const RadioToggleButton = (props) => {
    const classes = { ...useStyles(), ...props.classes };
    const {
        input,
        label,
        disabled,
        required,
        options,
        meta: { touched, error, invalid },
        xs,
        md,
        fieldLabelHelperText,
    } = props;

    return (
        <Grid container className={classes.fullWidth}>
            <FormControl
                className={classes.fullWidth}
                error={touched && invalid}
            >
                <FormLabel className={`${classes.label} ${classes.fullWidth}`}>
                    <span
                        className={touched && invalid ? classes.colorErr : ''}
                    >
                        {label}
                    </span>
                    {required && <span className={classes.colorErr}> *</span>}
                    {fieldLabelHelperText && (
                        <span className={classes.fieldLabelHelperText}>
                            {fieldLabelHelperText}
                        </span>
                    )}
                </FormLabel>
                <RadioGroup
                    className={classes.fullWidth}
                    value={String(input.value)}
                    onChange={(e) => input.onChange(e.target.value === 'true')}
                >
                    <Grid container>
                        {options.map((opt, index) => (
                            <Grid item key={index} xs={xs} md={md}>
                                <FormControlLabel
                                    value={String(opt.value)}
                                    control={
                                        <Radio
                                            classes={{
                                                checked: classes.checked,
                                            }}
                                            disabled={disabled}
                                            className={classes.styleMui}
                                        />
                                    }
                                    label={opt.label}
                                    classes={{ label: classes.fontLabel }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </RadioGroup>
                {touched && error && (
                    <FormHelperText className={classes.formHelper}>
                        {error}
                    </FormHelperText>
                )}
            </FormControl>
        </Grid>
    );
};

export default RadioToggleButton;
